import PlantIcon from 'components/icons/PlantIcon';
import { StyledHeadingContainer, StyledHeading } from './cards.style';

const Heading = ({
  color = '#329d9c',
  title = '',
  subtitle = ''
}: {
  color?: string;
  title: string;
  subtitle?: string;
}) => {
  if (!title) return null;

  return (
    <StyledHeadingContainer>
      <StyledHeading color={color}>
        <PlantIcon />
        <b>{title}</b>
      </StyledHeading>
      {subtitle && <StyledHeading>{subtitle}</StyledHeading>}
    </StyledHeadingContainer>
  );
};

export default Heading;
